import { Injectable } from '@angular/core';
import { map, Observable, of, catchError } from 'rxjs';
import { MsalService } from '@azure/msal-angular';
import { SilentRequest, AccountInfo } from '@azure/msal-browser';
import { environment } from '../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

const TOKEN_KEY = 'auth-token';
const TOKEN_EXPIRY_KEY = 'auth-token-expiry';
const REFRESHTOKEN_KEY = 'auth-refreshtoken';
const AUTH_API = environment.apiConfig.apiPath;
const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class TokenService{
  userData: any;
  appToken: any;

  constructor(private msalService: MsalService, private http: HttpClient) {
  }

  acquireTokenSilent(forceRefresh = false): Observable<string | null> {
    const account = this.msalService.instance.getActiveAccount() ?? this.msalService.instance.getAllAccounts()[0];

    if (!account) {
      return of(null);
    }

    const tokenRequest: SilentRequest = {
      scopes: environment.apiConfig1.scopes,
      account: account as AccountInfo,
      forceRefresh
    };

    return this.msalService.acquireTokenSilent(tokenRequest).pipe(
      map(response => {
        window.sessionStorage.setItem(TOKEN_KEY, response.accessToken);
        if (response.expiresOn) {
          window.sessionStorage.setItem(TOKEN_EXPIRY_KEY, response.expiresOn.getTime().toString());
        }
        return response.accessToken;
      }),
      catchError(() => of(null))
    );
  }

  getValidAccessToken(): Observable<string | null> {
    const cachedToken = window.sessionStorage.getItem(TOKEN_KEY);
    const expiryValue = window.sessionStorage.getItem(TOKEN_EXPIRY_KEY);
    const refreshBufferInMs = 60 * 1000;

    if (cachedToken && expiryValue) {
      const expiryTime = Number(expiryValue);
      if (!Number.isNaN(expiryTime) && Date.now() + refreshBufferInMs < expiryTime) {
        return of(cachedToken);
      }
    }

    return this.acquireTokenSilent();
  }

  logout() {
    return this.msalService.logout();
  }

  signOut(): void {
    window.sessionStorage.clear();
  }

  public saveToken(token: string): void {
    window.sessionStorage.setItem(TOKEN_KEY, token);
  }

  public getToken(): Observable<string | null> {
    return this.getValidAccessToken();
  }

  public saveRefreshToken(token: string): void {
    window.sessionStorage.setItem(REFRESHTOKEN_KEY, token);
  }

  public getRefreshToken(): string | null {
    return window.sessionStorage.getItem(REFRESHTOKEN_KEY);
  }

  isAuthenticated(): boolean {
    const accounts = this.msalService.instance.getAllAccounts();
    return !!accounts && accounts.length > 0;
  }

  getAccessTokenAndCallGraphAPI(): void{
   
    this.msalService.acquireTokenSilent({
      scopes: ['Group.Read.All', 'User.Read.All']
    }).subscribe(result=>{
      
    const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type':  'application/json',
          Authorization: 'Bearer '+ result.accessToken
          
    })}
     
    const reqBody = {
        "securityEnabledOnly": true
      }
      window.sessionStorage.setItem(TOKEN_KEY, result.accessToken);
    })
  }

  refreshToken(token: string): Observable<any> {
    return this.http.post(AUTH_API + '/refreshtoken', { refreshToken: token }, httpOptions);
  }
  // You can add more methods as needed, such as getting the user's token, etc.
}
